<div id="wrapped_home">
    <nav class="navbar navbar-expand-lg mt-1 sticky-top" style="background-color: #ffffff">
      <div class="container-fluid justify-content-center justify-content-xl-between">
        <div class="d-flex flex-row align-items-center">
          <a class="navbar-brand" href="#">
            <img id="logo_neocredito" class="img-fluid ms-lg-5" src="assets/img/logo.svg" alt="Logo neocredito" />
          </a>
          <a class="navbar-brand" href="https://www.bancoldex.com/" target="_blank">
            <img class="img-fluid ms-lg-5 d-block d-lg-none logo_bancoldex_home"
              src="assets/img/Home/svg/logo_bancoldex_morad.svg" alt="Logo bancoldex" />
          </a>
        </div>
        <div class="justify-content-lg-end" id="navbarHome">
          <div class="navbar-nav">
            <div class="d-flex flex-row mt-3 mt-lg-0">
              <a href="https://www.bancoldex.com/" target="_blank" class="mx-3 d-none d-lg-block">
                <img class="img-fluid ms-lg-5 logo_bancoldex_home" src="assets/img/Home/svg/logo_bancoldex_morad.svg"
                  alt="Logo bancoldex" />
              </a>
              <a id="btnRegistroIniciarSesion" routerLink="/login" class="gif-button-1-1 btn btn-iniciar_sesion active hvr-shrink mx-3 px-4"
                type="button">
                Iniciar Sesión</a>
              <div id="contenido-1-1" class="oculto-1-1">
                <img src="assets/video/GIF/01_Iniciar_sesion.gif" alt="" class="shadow">
              </div>


              <div class="btn-group">
                <button type="button" class="btn dropdown-toggle btn-iniciar_registro hvr-shrink px-4"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  ¡Solicítalo ya!
                </button>
                <div class="oculto-2">
                  <img src="assets/video/GIF/02_registrate.gif" alt="" class="shadow">
                </div>
                <div class="dropdown-menu dropdown-menu-right shadow-sm border-dark">
                  <a class="dropdown-item" routerLink="/registro/persona-natural">Persona natural</a>
                  <a class="dropdown-item" routerLink="/registro/persona-juridica">Persona jurídica</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
</div>
